import { PrizmLanguageInputLayout } from '../../interfaces';

export const PRIZM_RUSSIAN_INPUT: PrizmLanguageInputLayout = {
  inputLayout: {
    required: 'Обязательное поле',
    pattern: 'Неправильный формат',
    min: 'Значение слишком маленькое',
    max: 'Значение слишком большое',
    clear: 'Очистить',
  },
};
